import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const TAG_VERSION = {
    'amp-sticky-ad': '1.0',
    'amp-mustache': '0.2'
};

const AMPScript = ({ tag, version, ...props }) => {
    const extensionType = {
        [(/mustache/).test(tag) ? 'custom-template' : 'custom-element']: tag
    };
    const ver = version === AMPScript.defaultProps.version ? TAG_VERSION[tag] || version : version;

    return (
        <Helmet>
            <script async="async" {...extensionType} {...props} src={`https://cdn.ampproject.org/v0/${tag}-${ver}.js`} />
        </Helmet>
    );
};

AMPScript.propTypes = {

    /**
     * The name of the AMP component
     *
     * @example 'amp-facebook'
     */
    tag: PropTypes.string.isRequired,

    /**
     * The version number of the component
     *
     * @example '1.0'
     */
    version: PropTypes.string
};

AMPScript.defaultProps = {
    version: '0.1'
};

export default AMPScript;
